import { useLocation } from 'react-router-dom';
import { Logo } from '@/components/brand/logo';
import { Card, CardContent, CardDescription, CardHeader } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PRIVACY_POLICY, type PolicyText } from '../privacy-policy';

/**
 * Página pública, sem sessão: é o endereço que as plataformas pedem no cadastro do aplicativo.
 * Português primeiro (LGPD); inglês na aba ao lado, para a análise das plataformas — uma página
 * só, e não `/privacy` à parte, para as duas versões nunca se separarem. `#en` abre já em inglês:
 * é o link que vai no formulário das plataformas.
 */
export function PrivacyPage() {
  const { hash } = useLocation();
  return (
    <main className="mx-auto flex min-h-svh max-w-3xl flex-col gap-8 p-6">
      <Logo variant="horizontal" className="h-10 self-start" />
      <Tabs defaultValue={hash === '#en' ? 'en' : 'pt'}>
        <TabsList>
          <TabsTrigger value="pt">Português</TabsTrigger>
          <TabsTrigger value="en">English</TabsTrigger>
        </TabsList>
        <TabsContent value="pt" lang="pt-BR">
          <Policy text={PRIVACY_POLICY.pt} />
        </TabsContent>
        <TabsContent value="en" lang="en">
          <Policy text={PRIVACY_POLICY.en} />
        </TabsContent>
      </Tabs>
    </main>
  );
}

function Policy({ text }: { text: PolicyText }) {
  return (
    <Card>
      <CardHeader>
        <h1 className="text-xl font-semibold">{text.title}</h1>
        <CardDescription>{text.updated}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 text-sm">
        <p>{text.intro}</p>
        {text.sections.map((section) => (
          <section key={section.title} className="space-y-2">
            <Separator className="mb-4" />
            <h2 className="font-semibold">{section.title}</h2>
            {section.items ? (
              <ul className="list-disc space-y-1 pl-5">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
            {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </section>
        ))}
      </CardContent>
    </Card>
  );
}
